var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.points)?_c('svg',{attrs:{"width":40,"height":40,"viewBox":"0 0 40 40"}},[(_vm.isPolygon)?_c('polygon',{attrs:{"points":_vm.points,"fill":"#4a90e2","fill-opacity":"0.2","stroke":"#4a90e2","stroke-width":"2"}}):_c('polyline',{attrs:{"points":_vm.points,"fill":"none","stroke":"#4a90e2","stroke-width":"2"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }